import api from './api';

export const getBuyerClientsInGateway = (page, searchTerm, searchItem) => {
  return api.get('admin/stripe-sync/buyers', { params: { page, searchTerm, searchItem } });
};

export const createBuyerClientInGateway = (channelUid, tokenIdInGateway) => {
  return api.post('admin/stripe-sync/buyers', { channelUid, tokenIdInGateway });
};

export const updateBuyerClientInGateway = (channelUid, tokenIdInGateway) => {
  return api.put(`admin/stripe-sync/${channelUid}/buyers`, { tokenIdInGateway });
};
